import React from 'react';
import { Order, OrderType } from '@/types';
import OptionOrderCancelDialog from './OptionOrderCancelDialog';
import ChangeRequestOrderCancelDialog from './ChangeRequestOrderCancelDialog';
import PresetOrderCancelDialog from './PresetOrderCancelDialog';

export interface OrderCloseDialogCommonProps {
    show: boolean;
    onClose(): void;
    onOrderCancel(canceledOrderIds: number[]): void;
}

export interface OrderCloseDialogProps extends OrderCloseDialogCommonProps {
    order: Order;
}

const Switcher: React.FC<OrderCloseDialogProps> = ({ order, ...rest }) => {
    if (order.type === OrderType.ChangeRequest) {
        return <ChangeRequestOrderCancelDialog order={order} {...rest} />;
    } else if (order.type === OrderType.Option) {
        return <OptionOrderCancelDialog order={order} {...rest} />;
    } else if (order.type === OrderType.Preset) {
        return <PresetOrderCancelDialog order={order} {...rest} />;
    }

    return null;
};

export default Switcher;
